import { Outlet } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from './core/auth/AuthContext';
import { ModuleProvider } from './core/modules/ModuleContext';
import { TourProvider } from './core/tour/TourContext';
import { useTheme } from './core/theme/ThemeContext';

function App() {
  const { theme } = useTheme();

  return (
    <AuthProvider>
      <ModuleProvider>
        <TourProvider>
          <Outlet />
        </TourProvider>

        {/* Toast notifications */}
        <Toaster
          theme={theme}
          position="top-center"
          offset={14}
          visibleToasts={3}
          toastOptions={{
            duration: 4000,
            classNames: {
              toast: '!rounded-lg !shadow-md !border !text-sm !font-medium !items-center !py-2 !px-4 !min-h-0',
              success: '!bg-green-50 !border-green-200 !text-green-800 dark:!bg-green-900/30 dark:!border-green-800 dark:!text-green-300',
              error: '!bg-red-50 !border-red-200 !text-red-800 dark:!bg-red-900/30 dark:!border-red-800 dark:!text-red-300',
              warning: '!bg-amber-50 !border-amber-200 !text-amber-800 dark:!bg-amber-900/30 dark:!border-amber-800 dark:!text-amber-300',
              info: '!bg-blue-50 !border-blue-200 !text-blue-800 dark:!bg-blue-900/30 dark:!border-blue-800 dark:!text-blue-300',
            },
          }}
        />
      </ModuleProvider>
    </AuthProvider>
  );
}

export default App;
